module.exports = __webpack_public_path__ + "img/progress_073.d8084d1c.png";